// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Promotion from "../components/Promotion.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function getBrandLogoUrl(brand) {
  switch (brand) {
    case "lazada" :
        return "https://storage.googleapis.com/roza-public-assets/liff/lazada%20logo.svg";
    case "shopee" :
        return "https://storage.googleapis.com/roza-public-assets/liff/shopee%20logo.svg";
    default:
      return ;
  }
}

function ProfileCoupons(Props) {
  var coupons = Props.coupons;
  var items = Belt_Array.map(coupons, (function (coupon) {
          var img_url = Belt_Option.getExn(getBrandLogoUrl(coupon.brand));
          return React.createElement(Promotion.make, {
                      code: coupon.code,
                      img_url: img_url,
                      key: coupon.code
                    });
        }));
  return React.createElement(Promotion.Group.make, {
              children: items
            });
}

var make = ProfileCoupons;

export {
  getBrandLogoUrl ,
  make ,
  
}
/* react Not a pure module */
